import type { Product } from "@shopify/hydrogen/storefront-api-types";
import { Separator } from "@components/atoms/separator/index.client";
import { Markup } from "@components/atoms/markup/index.client";
import { Link, Money } from "@shopify/hydrogen";
import { translate } from "@locales";

export function ProductMobile({
  product,
  onRedirect,
}: {
  product: Product;
  onRedirect?: () => void;
}) {
  return (
    <Link
      to={`/products/${product.handle}`}
      onClick={onRedirect}
      className="flex gap-x-2 items-center pl-2 border border-custom-light-gray border-solid h-[100px] w-[335px]"
    >
      <img
        src={product.media.nodes[0].previewImage?.url}
        alt={product.media.nodes[0].alt ?? ""}
        className="w-[87px] h-[86px] object-cover"
      />
      <div>
        <h1 className="uppercase text-xs">{product.title}</h1>
        <Separator className="my-2" />
        <div className="flex items-center gap-x-[11px]">
          <Money
            data={product.variants.nodes[0].priceV2}
            className="text-custom-dark-blue text-sm"
          />
          {product.variants.nodes[0].availableForSale ? null : (
            <Markup color="grey" background className="mt-0">
              {translate("product-card.markup.out-of-stock")}
            </Markup>
          )}
        </div>
      </div>
    </Link>
  );
}
